import React, {FC} from 'react';

import {ModalOpenerComponent} from 'components/modal-opener-component';
import {ActionButton} from 'components/table/action/action-button';
import {ITableActionProps} from 'components/table/action/table-action-types';

import {useDwhDataPreparationModal} from '../hooks/use-dwh-data-preparation-modal';
import {DwhDataPreparationModalForm} from './dwh-data-preparation-modal-form';

interface IDwhDataPreparationModalOpenerProps extends ITableActionProps {
}

export const DwhDataPreparationModalOpener: FC<IDwhDataPreparationModalOpenerProps> = ({
    meta,
    wrapper,
    ...props
}: IDwhDataPreparationModalOpenerProps) => {
    const {
        modalRef,
        isOpen,
        form,
        operationType,
        setOperationType,
        setIsOpen,
        handleCloseModal,
        handleFinish,
    } = useDwhDataPreparationModal();

    const ActionButtonComponent = wrapper || ActionButton;

    return (
        <ModalOpenerComponent
            ref={modalRef}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            handleSave={() => {
                form.submit();
            }}
            handleCancel={setIsModalOpen => {
                handleCloseModal(setIsModalOpen);
            }}
            controlLabels={{save: 'Применить'}}
            hideControls={{cancel: true}}
            component={
                <ActionButtonComponent
                    {...props}
                    actionIcon={meta.actionIcon}
                >
                    {meta.actionTitle}
                </ActionButtonComponent>
            }
            modalProps={{title: 'Обновление данных', forceRender: true, centered: true, destroyOnClose: true}}
        >
            <DwhDataPreparationModalForm
                form={form}
                handleFinish={handleFinish}
                operationType={operationType}
                setOperationType={setOperationType}
            />
        </ModalOpenerComponent>
    );
};
